// lazyload-sections.js
class LazySection extends HTMLElement {
  static queue = new Set();
  static pendingIds = new Set(); // footer unhide ke liye
  static flushTimer = null;
  static BATCH_SIZE = 5; // Section Rendering API limit

  connectedCallback() {
    if (this._initialized) return;
    this._initialized = true;

    const wrapper =
      this.closest('.shopify-section[id^="shopify-section-"]') ||
      this.closest('[id^="shopify-section-"]');
    this.sectionId = wrapper ? wrapper.id.replace('shopify-section-', '') : null;
    if (!this.sectionId) return;

    this.trigger = this.dataset.triggerEvent || 'intersection-observer';
    if (this.trigger === 'mouseover' && window.innerWidth < 990) {
      this.trigger = 'intersection-observer'; // mobile par hover hota hi nahi
    }
    this.targetEl = document.querySelector(this.dataset.triggerTarget || 'body') || document.body;

    if (this.trigger === 'mouseover' || this.trigger === 'click') {
      this.onTrigger = () => {
        this.removeTrigger();
        this.request();
      };
      this.targetEl.addEventListener(this.trigger, this.onTrigger, { passive: true });
    } else {
      LazySection.pendingIds.add(this.sectionId);
      if (!('IntersectionObserver' in window)) {
        this.request();
        return;
      }
      this.observer = new IntersectionObserver(
        (entries) => {
          if (!entries[0].isIntersecting) return;
          this.observer.disconnect();
          this.request();
        },
        { rootMargin: '0px 0px 500px 0px' }
      );
      this.observer.observe(this);
    }
  }

  request() {
    if (this._requested) return;
    this._requested = true;
    LazySection.queue.add(this.sectionId);
    clearTimeout(LazySection.flushTimer);
    LazySection.flushTimer = setTimeout(LazySection.flush, 50);
  }

  static flush() {
    const ids = Array.from(LazySection.queue);
    LazySection.queue.clear();
    for (let i = 0; i < ids.length; i += LazySection.BATCH_SIZE) {
      LazySection.load(ids.slice(i, i + LazySection.BATCH_SIZE));
    }
  }

  static load(ids) {
    const url = new URL(window.location.href);
    url.hash = '';
    url.searchParams.set('sections', ids.join(','));

    fetch(url.toString())
      .then((response) => {
        if (!response.ok) throw new Error('Section fetch failed: ' + response.status);
        return response.json();
      })
      .then((json) => {
        Object.entries(json).forEach(([key, html]) => LazySection.render(key, html));
      })
      .catch((e) => console.warn('lazy-section:', e))
      .finally(() => {
        ids.forEach((id) => LazySection.pendingIds.delete(id));
        LazySection.afterLoad();
      });
  }

  static render(key, html) {
    const target = document.getElementById('shopify-section-' + key);
    if (!target || !html) return;

    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.getElementById('shopify-section-' + key);
    if (!fresh || !fresh.innerHTML.trim().length) return;

    target.innerHTML = fresh.innerHTML;

    // innerHTML se aaye scripts execute nahi hote, isliye dobara bana ke chalao
    target.querySelectorAll('script').forEach((oldScript) => {
      const newScript = document.createElement('script');
      Array.from(oldScript.attributes).forEach((attr) => newScript.setAttribute(attr.name, attr.value));
      newScript.textContent = oldScript.textContent;
      oldScript.replaceWith(newScript);
    });

    document.dispatchEvent(new CustomEvent('lazy-section:loaded', { detail: { id: key } }));
  }

  static afterLoad() {
    // Sab intersection-wale sections load ho gaye to footer dikhao
    if (LazySection.pendingIds.size === 0) {
      const footer = document.querySelector('footer.footer');
      if (footer) footer.classList.remove('hidden');
    }
    if (typeof quickAddToCart === 'function') quickAddToCart();
  }

  removeTrigger() {
    if (this.targetEl && this.onTrigger) {
      this.targetEl.removeEventListener(this.trigger, this.onTrigger);
    }
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
    this.removeTrigger();
  }
}

if (!customElements.get('lazy-section')) {
  customElements.define('lazy-section', LazySection);
}